export default __webpack_public_path__ + "static/logo_assc_Hacia@2x-06b948f6e7cdc3379709eaa15affde2e.png";